class foodBenefitManager {
  constructor() {
  }

}

export default foodBenefitManager;



// WEBPACK FOOTER //
// ./client/app/common/domain/models/foodBenefitManager.js